import { render, staticRenderFns } from "./AppleLoginButton.vue?vue&type=template&id=73a99f8a&"
import script from "./AppleLoginButton.vue?vue&type=script&lang=ts&"
export * from "./AppleLoginButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports